import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Download = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 6.25C27 5.14543 26.1046 4.25 25 4.25C23.8954 4.25 23 5.14543 23 6.25V26.4216L15.9977 19.4193C15.2167 18.6382 13.9503 18.6382 13.1693 19.4193C12.3882 20.2003 12.3882 21.4667 13.1693 22.2477L23.5859 32.6644C23.6104 32.6889 23.6355 32.7126 23.661 32.7357C23.9674 33.012 24.3596 33.1948 24.7929 33.2394C24.8614 33.2465 24.9306 33.2502 25.0002 33.2502C25.0781 33.2502 25.1555 33.2456 25.2321 33.2367C25.6771 33.1847 26.0944 32.9844 26.4144 32.6644L36.831 22.2477C37.6121 21.4667 37.6121 20.2003 36.831 19.4193C36.05 18.6382 34.7837 18.6382 34.0026 19.4193L27 26.4219V6.25ZM6.25 29.2502C7.35457 29.2502 8.25 30.1457 8.25 31.2502V39.5836C8.25 40.1582 8.47827 40.7093 8.8846 41.1156C9.29093 41.522 9.84203 41.7502 10.4167 41.7502H39.5833C40.158 41.7502 40.7091 41.522 41.1154 41.1156C41.5217 40.7093 41.75 40.1582 41.75 39.5836V31.2502C41.75 30.1457 42.6454 29.2502 43.75 29.2502C44.8546 29.2502 45.75 30.1457 45.75 31.2502V39.5836C45.75 41.2191 45.1003 42.7876 43.9438 43.9441C42.7873 45.1005 41.2188 45.7502 39.5833 45.7502H10.4167C8.78116 45.7502 7.21265 45.1005 6.05617 43.9441C4.8997 42.7876 4.25 41.2191 4.25 39.5836V31.2502C4.25 30.1457 5.14543 29.2502 6.25 29.2502Z"
        fill={color}
      />
    </svg>
  )
}
